import React, { useCallback, useEffect, useState } from 'react'
import { Box, Paper, Theme, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next'
import TextFieldComponent from '@professocial/professocialFormComponents/FormComponents/TextFieldComponent'
import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'
import DialogComponent from '@professocial/professocialFormComponents/FormComponents/DialogComponent'
import { SetOrUpdateImprintRequest } from '@professocialApi/professocial-core-frontend-api/apis/ImprintApi'
import { UpdateImprintRequest } from '@professocialApi/professocial-core-frontend-api/models/UpdateImprintRequest'
import { getPotentialPageImprintInitiated, setOrUpdateImprintInitiated } from '../../../store/common/common.actions'
import { useDispatch, useSelector } from 'react-redux'
import { getImprint, getUser } from '../../../store/common/common.selectors'
import { UserSettings } from '@professocialApi/professocial-core-frontend-api'
import FacebookTemplateTextarea
  from '@professocial/professocialFacebookSettings/src/shared/components/ModuleComponents/FacebookTemplateTextarea'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minWidth: '300px',
    width: '100%',
    margin: theme.spacing(3),
    padding: theme.spacing(4),
  },
  imprintInput: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
}))

const EditorImprint: React.FC = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const [imprint, setImprint] = useState<string>()
  const [open, setOpen] = useState<boolean>(false)
  const [isDirty, setIsDirty] = useState<boolean>(false)

  const user: UserSettings | undefined = useSelector(getUser)

  const dispatchSetOrUpdateImprintRequest = useCallback((params: SetOrUpdateImprintRequest) => dispatch(setOrUpdateImprintInitiated(params)), [dispatch])
  const dispatchGetPotentialPageImprint = useCallback(() => dispatch(getPotentialPageImprintInitiated()), [dispatch])

  const potentialPageImprint = useSelector(getImprint)

  const sendImprintRequest = (updateAll: boolean) => {
    setOpen(false)

    if (imprint && user?.mandator) {
      const imprintRequest: UpdateImprintRequest = {
        imprintText: imprint,
        mandatorId: user.mandator.id,
      }

      const request: SetOrUpdateImprintRequest = {
        updateImprintRequest: imprintRequest,
        updateForAllUsers: updateAll,
      }

      dispatchSetOrUpdateImprintRequest(request)
    }
  }

  useEffect(() => {
    dispatchGetPotentialPageImprint()
  }, [])

  return (
    <Paper className={classes.root}>
      <form>
        <Typography>{t('coreImprint:explanation')}</Typography>
        <TextFieldComponent
          className={classes.imprintInput}
          id='imprint'
          variant='outlined'
          label={t('coreImprint:detailedDescription')}
          value={imprint || potentialPageImprint?.imprintText}
          multiline
          rows={6}
          onChange={(event) => { setImprint(event.target.value); setIsDirty(true) }}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            maxLength: 500,
          }}
          helperText={`${imprint?.length || potentialPageImprint?.imprintText?.length}/500`}
        />
        <Box style={{ display: 'flex', justifyContent: 'center' }}>
          <Box style={{ flexGrow: 1 }} />
          <ButtonComponent text={t('coreImprint:saveChanges')} onClick={() => setOpen(true)} disabled={!isDirty || (imprint?.trim().length === 0)} />
          <DialogComponent
            type='warning'
            autoClose={false}
            message={t('coreImprint:updateAll')}
            open={open}
            confirmLabel={t('coreCommon:yes')}
            cancelLabel={t('coreImprint:onlySave')}
            requestActions
            onClose={() => setOpen(false)}
            onCancel={() => sendImprintRequest(false)}
            onConfirm={() => sendImprintRequest(true)}
          />
        </Box>
      </form>
    </Paper>
  )
}

export default EditorImprint
